<template>
  <section class="table-sampler-classification-noise table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="bg-grey text-left" style="width:25%;">Campo</th>
          <th class="text-center" style="width:37.5%;">NHO 01</th>
          <th class="text-center" style="width:37.5%;">NR 15</th>
        </tr>
      </thead>
      <tbody>
        <!-- Consideração técnica -->
        <tr>
          <td class="bg-grey">Consideração técnica</td>
            <td>
              <select class="form-control" v-model="model.nho.consideration" required>
              <option v-if=" model?.nho?.consideration &&
                !Object.values(noiseSettings.nho || {}).some(item => item.technicalConsiderations === model.nho.consideration)"
                :value="model.nho.consideration"
              >
                {{ model.nho.consideration }}
              </option>
                <option v-for="(level, levelKey) in noiseSettings.nho" :key="levelKey">{{ level.technicalConsiderations }}</option>
              </select>
            </td>
          <td>
            <select class="form-control" v-model="model.nr15.consideration" required>
              <option v-if=" model?.nr15?.consideration &&
              !Object.values(noiseSettings.nr15 || {}).some(item => item.technicalConsiderations === model.nr15.consideration)"
              :value="model.nr15.consideration"
            >
              {{ model.nr15.consideration }}
            </option>
              <option v-for="(level, levelKey) in noiseSettings.nr15" :key="levelKey">{{ level.technicalConsiderations }}</option>
            </select>
          </td>
        </tr>
        <!-- Dose diária -->
        <tr>
          <td class="bg-grey">Dose diária (%)</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.dose_daily" @input="updateFields(model.nho.dose_daily, 'nho')" placeholder="Dose diária (%) NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.dose_daily" @input="updateFields(model.nr15.dose_daily, 'nr15')" placeholder="Dose diária (%) NR 15" />
          </td>
        </tr>
        <!-- LEO -->
        <tr>
          <td class="bg-grey">LEO (%)</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.leo" placeholder="LEO (%) NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.leo" placeholder="LEO (%) NR 15" />
          </td>
        </tr>
        <!-- Atuação recomendada -->
        <tr>
          <td class="bg-grey">Atuação recomendada</td>
          <td>
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.nho.recommended_action" placeholder="Atuação recomendada NHO 01" />
          </td>
          <td>
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.nr15.recommended_action" placeholder="Atuação recomendada NR 15" />
          </td>
        </tr>
        <!-- Recomendação da exposição -->
        <tr>
          <td class="bg-grey">Recomendação da exposição</td>
          <td colspan="2">
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.recomendation" placeholder="Recomendação da exposição" />
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { mapActions } from 'vuex';
import { NOISE } from '_modules/settings/components/SettingsModel';
import { NOISE_CLASSIFICATION, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Classification-Noise',
  props: {
    classification: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_CLASSIFICATION),
    };
  },
  computed: {
    noiseSettings() {
      const { noise } = this.$store.state.settings.results;
      if (noise) {
        return noise;
      }
      return { ...NOISE };
    },
  },
  methods: {
    ...mapActions([
      'getSettings',
    ]),
    setModel() {
      if (this.classification) {
        if (this.classification.nho && this.classification.nr15) {
          this.model = cloneDeep(this.classification);
        } else {
          this.model = cloneDeep({ ...this.classification, nho: this.classification, nr15: this.classification });
        }
      }
    },
    updateFields(dose, type) {
      const numberRegex = /[-+]?\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(\.\d+)?/g;

      if (!dose || !numberRegex.test(dose)) {
        this.model[type].bgColor = null;
        this.model[type].consideration = null;
        this.model[type].recommended_action = null;
        return;
      }

      const levels = Object.entries(this.noiseSettings[type]);
      const matchingEntry = this.findLevelMatch(dose, levels);

      if (matchingEntry) {
        const [matchingKey, matchingLevel] = matchingEntry;
        this.model[type].consideration = matchingLevel ? matchingLevel.technicalConsiderations : null;
        this.model[type].recommended_action = matchingLevel ? matchingLevel.recommendedAction : null;
        this.model[type].bgColor = this.noiseSettings[type][matchingKey].bgColor || '#cfcfc4';
      }
    },
    findLevelMatch(dose, levels) {
      const doseValue = this.convertToNumber(dose);

      return levels.find(level => {
        const min = level[1].dailyDoseMin ? this.convertToNumber(level[1].dailyDoseMin) : -Infinity;
        const max = level[1].dailyDoseMax ? this.convertToNumber(level[1].dailyDoseMax) : Infinity;
        return doseValue >= min && doseValue < max;
      });
    },
    convertToNumber(value) {
      if (value) {
        const number = parseFloat(value.toString().replace(/,/g, '.'));
        if (!Number.isNaN(number) && number !== 0) {
          return number;
        }
      }
      return null;
    },
  },
  mounted() {
    this.getSettings()
      .then(() => this.setModel());
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:classification', value);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
td {
  vertical-align: middle;
}

input {
  min-width: 150px;
}
</style>
